<template>
    <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
                 :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
            <el-form-item label="会员ID:" prop="memberId">
                <el-input v-model="dataForm.memberId" placeholder="会员ID"></el-input>
            </el-form-item>
            <el-form-item label="账户类型:" prop="balanceType">
                <el-select v-model="dataForm.balanceType" placeholder="请选择账户类型">
                    <el-option v-for="item in balanceTypes"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="操作类型:" prop="operatType">
                <el-select v-model="dataForm.operatType" placeholder="请选择操作类型">
                    <el-option v-for="items in operatTypes"
                               :key="items.value"
                               :label="items.label"
                               :value="items.value"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="改变类型:" prop="changeType">
                <el-select v-model="dataForm.changeType" placeholder="改变类型">
                    <el-option v-for="item in changeTypes"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="改变数值" prop="changeNumber">
                <el-input v-model="dataForm.changeNumber" placeholder="改变数值"></el-input>
            </el-form-item>
            <el-form-item label="余额" prop="balance">
                <el-input v-model="dataForm.balance" placeholder="余额"></el-input>
            </el-form-item>
            <el-form-item label="流水备注" prop="note">
                <el-input v-model="dataForm.note" placeholder="流水备注"></el-input>
            </el-form-item>
            <el-form-item label="订单编号" prop="orderId">
                <el-input v-model="dataForm.orderId" placeholder="订单编号"></el-input>
            </el-form-item>
        </el-form>
        <template slot="footer">
            <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
            <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
        </template>
    </el-dialog>
</template>

<script>
    import debounce from 'lodash/debounce'

    export default {
        data() {
            return {
                visible: false,
                changeTypes: [
                    {
                        value: 1,
                        label: '增加'
                    }, {
                        value: 2,
                        label: '减少'
                    }],
                balanceTypes: [{
                    value: 1,
                    label: '现金'
                }, {
                    value: 2,
                    label: '优果'
                }],
                operatTypes: [{
                    value: 10,
                    label: '直邀优客分成'
                }, {
                    value: 11,
                    label: "直邀够买分成"
                }, {
                    value: 13,
                    label: "间邀够买分成"
                }, {
                    value: 19,
                    label: "提现"
                }, {
                    value: 20,
                    label: "注册赠送"
                }, {
                    value: 21,
                    label: "转赠减少"
                }, {
                    value: 22,
                    label: "获赠增加"
                }, {
                    value: 23,
                    label: "本人节点生成"
                }, {
                    value: 24,
                    label: "V1团队节点分成"
                }, {
                    value: 25,
                    label: "V2团队节点分成"
                }, {
                    value: 26,
                    label: "精英团队节点分成"
                }, {
                    value: 27,
                    label: "合伙人团队节点分成"
                }, {
                    value: 28,
                    label: "区域节点分成"
                }],
                dataForm: {
                    id: '',
                    memberId: '',
                    balanceType: '',
                    operatType: '',
                    changeType: '',
                    changeNumber: '',
                    balance: '',
                    note: '',
                    orderId: '',
                    creator: '',
                    deptId: '',
                    createDate: '',
                    updateDate: ''
                }
            }
        },
        computed: {
            dataRule() {
                return {
                    memberId: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    balanceType: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    operatType: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    changeType: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    changeNumber: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    balance: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    note: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    orderId: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    deptId: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    updateDate: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ]
                }
            }
        }
        ,
        methods: {
            init() {
                this.visible = true
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields()
                    if (this.dataForm.id) {
                        this.getInfo()
                    }
                })
            }
            ,
            // 获取信息
            getInfo() {
                this.$http.get(`/ums/memberbalancecharge/${this.dataForm.id}`).then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.dataForm = {
                        ...this.dataForm,
                        ...res.data
                    }
                }).catch(() => {
                })
            }
            ,
            // 表单提交
            dataFormSubmitHandle: debounce(function () {
                this.$refs['dataForm'].validate((valid) => {
                    if (!valid) {
                        return false
                    }
                    this.$http[!this.dataForm.id ? 'post' : 'put']('/ums/memberbalancecharge/', this.dataForm).then(({data: res}) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg)
                        }
                        this.$message({
                            message: this.$t('prompt.success'),
                            type: 'success',
                            duration: 500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    }).catch(() => {
                    })
                })
            }, 1000, {'leading': true, 'trailing': false})
        }
    }
</script>
